// PRD 9.2 — what makes a trial-points exception submittable. Pure so it can be tested without the
// modal; the server re-validates all of it, this only keeps the operator from a pointless round trip.

// DECIMAL(4,2) in MySQL, so anything finer than 2dp is silently rounded on the way in.
export const TRIAL_POINTS_EXCEPTION_MAX_CHARGE = 10;
// VARCHAR(500) NOT NULL — a longer reason is error 1406, or a silent truncation.
export const TRIAL_POINTS_EXCEPTION_MAX_REASON = 500;
export const TRIAL_POINTS_EXCEPTION_MIN_REASON = 3;

// A charge the column can store exactly. CustomInput drops min/max/step, so this is the only gate.
export function is_storable_charge(raw) {
  if (raw === '' || raw === null || raw === undefined) return false;
  const charge = Number(raw);
  if (!Number.isFinite(charge)) return false;
  if (charge < 0 || charge > TRIAL_POINTS_EXCEPTION_MAX_CHARGE) return false;
  // 0.005 would pass the range check and then be stored as 0.01 — a value nobody typed.
  return Number(charge.toFixed(2)) === charge;
}

export function is_valid_reason(raw) {
  const reason = (raw || '').trim();
  return (
    reason.length >= TRIAL_POINTS_EXCEPTION_MIN_REASON &&
    reason.length <= TRIAL_POINTS_EXCEPTION_MAX_REASON
  );
}

// An exception must DO something — a reason alone would save a note that changes no points.
export function is_valid_trial_points_exception({ waived, custom_enabled, charge, reason }) {
  if (!is_valid_reason(reason)) return false;
  if (waived) return true;
  if (!custom_enabled) return false;
  return is_storable_charge(charge);
}
